import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { canAccess } from "@/lib/rbac";
import { findItemByPath } from "@/config/modules";
import { Loader2 } from "lucide-react";
import { EmptyState } from "@/components/common/States";
import { ShieldAlert } from "lucide-react";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-[#FAF8F5]">
        <Loader2 className="h-8 w-8 animate-spin text-amber-700" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;

  const item = findItemByPath(location.pathname);
  if (item && !canAccess(user.role, item.roles)) {
    return (
      <div className="mx-auto max-w-2xl py-10">
        <EmptyState
          icon={ShieldAlert}
          title="Access restricted"
          message="Your role doesn’t have permission to view this module. Authorization is enforced by the backend."
        />
      </div>
    );
  }
  return children;
}
